import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { LoadingSpinnerComponent } from '../loading-spinner/loading-spinner.component';

@Component({
    selector: 'lib-loading-screen',
    imports: [CommonModule, LoadingSpinnerComponent],
    templateUrl: './loading-screen.component.html',
    styleUrl: './loading-screen.component.css'
})
export class LoadingScreenComponent {
    title: string = 'Please wait';
    text: string = '';
}
